import { Helpers } from '@front/utils/index';
import { createComponent } from '@front/utils/alpine';
const Contact = createComponent(() => ({
    form: '',
    toggle: false,
    isLoading: false,
    captchaMeta: null,
    captchaValue: '',
    async init() {
        this.captchaMeta = document.querySelector('meta[name="google-captcha-public-key"]');
        if (this.captchaMeta !== null && this.captchaMeta.content) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = `https://www.google.com/recaptcha/api.js?render=${this.captchaMeta.content}`;
            script.onload = () => {
                grecaptcha.ready(() => {
                    grecaptcha
                        .execute(this.captchaMeta ? this.captchaMeta.content : '')
                        .then((token) => {
                        this.captchaValue = token;
                    });
                });
            };
            document.body.appendChild(script);
        }
    },
    isMobile() {
        return Helpers.Screen.isWiderThanBreakpoint('md')
            ? false
            : this.setSubject();
    },
    setSubject() {
        this.form = this.$el.dataset.subject;
        return true;
    },
}));
export { Contact };
